module.exports = __webpack_public_path__ + "img/showcase_purple.88a644a9.png";